module.exports = __webpack_public_path__ + "static/media/70676.b1b95218.jpg";